/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from '../../common/LoadingSpinner';
import DropDown from '../../common/DropDown';
import AddPaymentContainer from '../../payments/addpayment/addPaymentContainer';
import history from "../../../history";
import { jobModes } from "../../../consts";
import isEqual from "lodash/isEqual";

const mapOptionToDisplay = option => {
    if (option.provider === 'banktransfer') {
        return {
            title: 'Pay by bank transfer on invoice',
            shortTitle: 'bank transfer',
            info: '',
        };
    } else if (option.provider === 'stripe') {
        return {
            title: 'Pay by card',
            shortTitle: 'card',
            info: '',
        };
    } else if (option.add_payment_option) {
        return {
            title: option.add_payment_option,
            shortTitle: 'method',
            info: '',
        };
    } else {
        return {
            title: '',
            shortTitle: '',
            info: '',
        };
    }
}

const cardPaymentMethods = [
    {
        add_payment_option: 'Pay by card',
        value: 'stripe',
        provider: 'stripe',
        style: 'payment-dropdown-option--info-no-margin',
        position: 1,
    },
];

const setLaterPaymentMethods = [
    {
        add_payment_option: 'Notify client to complete a payment (job will remain in checkout)',
        value: 'set_later',
        provider: 'n/a',
        style: 'payment-dropdown-option--info-no-margin',
        position: 2,
        overridesDefault: true,
    },
];

class PaymentDropdown extends DropDown {
    constructor(props) {
        super(props);

        this.state = {
            showRemovePaymentModal: false,
            selected: null,
        };

        this.selectPaymentMethod = this.selectPaymentMethod.bind(this);
        this.onModalDismiss = this.onModalDismiss.bind(this);
        this.loadOptions = this.loadOptions.bind(this);
        this.reorderOptions = this.reorderOptions.bind(this);
        this.deletePaymentMethod = this.deletePaymentMethod.bind(this);
    }

    componentDidMount() {
        // Selects default payment method
        if (this.props.paymentMethods) {
            this.loadOptions();
            this.reorderOptions();

            const locationState = history.location.state;
            if (locationState?.stripeClientSecret) {
                const stripe = this.options.find(option => option.provider === 'stripe');
                this.selectPaymentMethod(stripe);
                return;
            }

            const defaultPaymentMethod = this.options.find(option => option.is_default);
            this.selectPaymentMethod(defaultPaymentMethod || this.options[0]);
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.paymentMethods) return;

        const paymentMethodsChanged = !isEqual(prevProps.paymentMethods, this.props.paymentMethods);
        const clientIdChanged = prevProps.clientData && prevProps.clientData.id !== this.props.clientData.id;

        if (paymentMethodsChanged) {
            this.loadOptions();
            this.reorderOptions();
        }

        if (paymentMethodsChanged || clientIdChanged) {
            let paymentMethod = this.options.find(option => option.id && option.id === this.props.paymentMethod);
            if (!paymentMethod) {
                paymentMethod = this.options.find(option => option.is_default);
            }
            if (!paymentMethod || (this.props.mode !== jobModes.EDIT && paymentMethod.provider === 'stripe')) {
                paymentMethod = this.options.find(option => option.overridesDefault);
            }
            this.selectPaymentMethod(paymentMethod || this.options[0]);
        }
    };

    loadOptions = () => {
        this.options = [...this.props.paymentMethods];
        if (this.props.enableAddStripe && !this.options.some(option => option.provider === 'stripe')) {
            this.options = [...this.options, ...cardPaymentMethods];
        }
        if (this.props.enableSetLater) {
            this.options = [...this.options, ...setLaterPaymentMethods];
        }
    };

    reorderOptions = () => {
        this.options = this.options
            .map(option => ({
                ...option,
                value: option.url || option.value,
            }))
            .sort((option1, option2) => {
                if (option1.is_default) {
                    return -1;
                }
                if (option2.is_default) {
                    return 1;
                }
                if (
                    (option1.provider === 'banktransfer' && option2.add_payment_option) ||
                    (!option1.add_payment_option && option2.provider === 'banktransfer')
                ) {
                    return -1;
                }
                if (
                    (option2.provider === 'banktransfer' && option1.add_payment_option) ||
                    (!option2.add_payment_option && option1.provider === 'banktransfer')
                ) {
                    return 1;
                }
                if (option1.add_payment_option && !option2.add_payment_option) {
                    // Put payment method at the end
                    return 1;
                }
                if (option2.add_payment_option && !option1.add_payment_option) {
                    return -1;
                }
                if (option1.add_payment_option && option2.add_payment_option && option1.provider === option2.provider) {
                    return option1.position - option2.position;
                }
                return option1.provider.localeCompare(option2.provider); // Sort by provider name
            });
    };

    selectPaymentMethod(paymentMethod) {
        this.setState({ selected: paymentMethod });
        this.props.onPaymentMethodSelect(paymentMethod);
    }

    onFilterChange = (filterKey, selected) => this.selectPaymentMethod(selected);

    deletePaymentMethod = () => this.setState({ showRemovePaymentModal: true });

    onModalDismiss = () => this.setState({ showRemovePaymentModal: false });

    renderSelected = (value, isOpen) =>
        value ? (
            this.renderOption(value)
        ) : (
            <div className="dropdown-placeholder">Choose a payment method</div>
        );

    renderOption = option => {
        const displayOption = mapOptionToDisplay(option);
        return (
            <div className="display-flex payment-dropdown-option">
                {(option.img_url || option.bank_logo) && option.provider !== 'banktransfer' ? (
                    <img src={option.img_url || option.bank_logo} />
                ) : null}
                <div className={`display-flex payment-dropdown-option--info ${option.style ? option.style : ''}`}>
                    <div>{displayOption.title}</div>
                    <div>{displayOption.info}</div>
                </div>
            </div>
        );
    };

    render() {
        return this.props.paymentMethods === undefined ? (
            <LoadingSpinner className="small" />
        ) : (
            <div>
                <DropDown
                    options={this.options}
                    defaultSelection={this.state.selected}
                    renderSelected={this.renderSelected}
                    onFilterChange={this.onFilterChange}
                    renderOption={this.renderOption}
                    scrollTop={true}
                />
                {this.state.selected?.id && this.state.selected.removable && !this.props.hideRemoveLink && (
                    <a onClick={this.deletePaymentMethod}>
                        {`Remove ${mapOptionToDisplay(this.state.selected).shortTitle}...`}
                    </a>
                )}
                <AddPaymentContainer
                    mode="remove_method"
                    paymentMethod={this.state.selected}
                    isOpen={this.state.showRemovePaymentModal}
                    onRequestClose={this.onModalDismiss}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        clientData: state.clientData.basicInfo,
        paymentMethods: state.clientData.paymentMethods,
    };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
    PaymentDropdown,
);
